import { cva } from 'class-variance-authority';

/**
 * Varian gaya tombol.
 *
 * Dipisahkan dari `button.tsx` agar berkas komponen hanya mengekspor
 * komponen — syarat React Fast Refresh bekerja dengan benar. Juga
 * dipakai langsung oleh elemen lain yang ingin tampil seperti tombol,
 * mis. `<Link className={buttonVariants({ variant: 'outline' })}>`.
 */
export const buttonVariants = cva(
  [
    'inline-flex items-center justify-center gap-2 whitespace-nowrap font-medium',
    'transition-[background-color,border-color,color,box-shadow] duration-150',
    'focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--color-ring)]',
    'disabled:pointer-events-none disabled:opacity-50',
    '[&_svg]:shrink-0 [&_svg]:size-4',
  ],
  {
    variants: {
      variant: {
        // `btn-primary` bukan class Tailwind — ia penanda agar tema neon bisa
        // memberi tombol utama gradien aksen. Warna ratanya tetap ada sebagai
        // dasar, jadi tema tanpa gradien tidak berubah sama sekali.
        primary:
          'btn-primary bg-[var(--color-primary)] text-[var(--color-primary-foreground)] shadow-xs hover:bg-[var(--color-primary-hover)]',
        secondary:
          'bg-[var(--color-secondary)] text-[var(--color-secondary-foreground)] hover:bg-[var(--color-accent)]',
        outline:
          'border border-[var(--color-border)] bg-[var(--color-card)] text-[var(--color-foreground)] hover:bg-[var(--color-accent)]',
        ghost: 'text-[var(--color-foreground)] hover:bg-[var(--color-accent)]',
        destructive:
          'bg-[var(--color-destructive)] text-[var(--color-destructive-foreground)] shadow-xs hover:opacity-90',
        link: 'text-[var(--color-primary)] underline-offset-4 hover:underline',
      },
      size: {
        sm: 'h-8 rounded-[var(--radius-sm)] px-3 text-xs',
        md: 'h-10 rounded-[var(--radius-md)] px-4 text-sm',
        lg: 'h-11 rounded-[var(--radius-md)] px-6 text-base',
        icon: 'size-10 rounded-[var(--radius-md)]',
      },
      fullWidth: {
        true: 'w-full',
      },
    },
    defaultVariants: {
      variant: 'primary',
      size: 'md',
    },
  },
);
